module.exports = __webpack_public_path__ + "static/media/slide2.63478da7.png";